
import utils from '@/utils/utils'
const { checkPermission } = utils;

export const permissionMix = {
    computed: {

        profile() {
            return this.$store.state.user.profile;
        },
    },
    methods: {
        checkPermission
    }
};
